var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"custimer-inner"},[_c('div',{staticClass:"customer-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"logos animated fadeInUp slow"},[_c('ul',_vm._l((_vm.logos),function(item,index){return _c('li',{key:index},[_c('img',{staticClass:"gray",attrs:{"src":item.url}})])}),0),_vm._v(" "),_c('div',{staticClass:"btn",staticStyle:{"margin-top":"10px"}},[_c('a',{on:{"click":_vm.goCustomer}},[_vm._v("客户案例")])])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeInDown slow"},[_c('div',{staticClass:"title"},[_vm._v("我们的客户")])])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/home/customer.vue?vue&type=template&id=1f4bce6e&scoped=true
// module id = null
// module chunks = 